import React from 'react';
import Zoom from 'react-reveal/Zoom';

function Timeline({ data, index }) {
  const { description, year, title } = data;

  return (
    <Zoom bottom>
      <div className={`single-event-container ${index % 2 === 0 && 'right'}`}>
        <div className='event-description'>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        <div className='border'></div>
        <div className='circle-date'>{year}</div>
      </div>
    </Zoom>
  );
}

export default Timeline;
